export default "__VITE_ASSET__C2yVh7eH__"